import styled from "styled-components"
import { DefaultTheme } from "components/Layout/styles"

const SContainer = styled.div`
    margin-top: 1rem;
    margin-bottom: 1rem;
`
const PrimaryText = styled.span`
    color: #192F54;
    font-weight: 600;
`

const SAnchor = styled.button`
    background: none;
    padding: 0;
    margin: 0;
    border: 0;
    color: ${DefaultTheme.colors.accent};

    &:hover {
        text-decoration: underline;
    }
`

export {SContainer, PrimaryText, SAnchor}